import { Polygon } from "geojson";

import { siteStore } from "../store";

export const setUtilityGeometry = (geometry?: Polygon) => (siteStore.utilityGeometry = geometry);
